import {
  prisma,
  UnifonicChannel,
  WhatsappChannel,
  ResourceType,
  ActionType,
  CommunicationLevel,
  WhatsappChannelType,
} from "client";

// CREATE
export const createWhatsappChannel = async (
  userId: string,
  data: WhatsappChannel
) => {
  try {
    const whatsappChannel = await prisma.whatsappChannel.create({
      data: {
        communicationChannel: { connect: { id: data.communicationChannelId } },
        type: data.type,
      },
    });
    return { whatsappChannel };
  } catch (error) {
    return { error };
  }
};

// create whatsapp channel with  twilio auth token and account sid and phone number and communication channel id
export const createWhatsappChannelWithTwilio = async (
  userId: string,
  entityId: string,
  twilioAuthToken: string,
  twilioAccountSid: string,
  twilioPhoneNumber: string,
  communicationChannelId?: string,
  level?: CommunicationLevel
) => {
  try {
    let connect = {};
    switch (level) {
      case CommunicationLevel.WHITE_LABEL:
        connect = { whiteLabel: { connect: { id: entityId } } };
        break;
      case CommunicationLevel.EVENT:
        connect = { event: { connect: { id: entityId } } };
        break;
      case CommunicationLevel.ORGANIZATION:
        connect = { organization: { connect: { id: entityId } } };
        break;
      case CommunicationLevel.EXHIBITOR:
        connect = { exhibitor: { connect: { id: entityId } } };
        break;

      default:
        connect = { whiteLabel: { connect: { id: entityId } } };
        break;
    }
    const communicationChannel = communicationChannelId
      ? null
      : await prisma.communicationChannel.create({
          data: {
            level: level || CommunicationLevel.WHITE_LABEL,
            ...connect,
          },
        });
    const whatsappChannel = await prisma.whatsappChannel.create({
      data: {
        communicationChannel: {
          connect: { id: communicationChannel?.id || communicationChannelId },
        },
        type: WhatsappChannelType.TWILIO,
        twilioChannel: {
          create: {
            authToken: twilioAuthToken,
            accountSid: twilioAccountSid,
            phoneNumber: twilioPhoneNumber,
          },
        },
      },
    });

    return { whatsappChannel };
  } catch (error) {
    return { error };
  }
};

export const createWhatsappChannelWithUnifonic = async (
  userId: string,
  entityId: string,
  channelData: UnifonicChannel,
  communicationChannelId?: string,
  level?: CommunicationLevel
) => {
  try {
    let connect = {};
    switch (level) {
      case CommunicationLevel.WHITE_LABEL:
        connect = { whiteLabel: { connect: { id: entityId } } };
        break;
      case CommunicationLevel.EVENT:
        connect = { event: { connect: { id: entityId } } };
        break;
      case CommunicationLevel.ORGANIZATION:
        connect = { organization: { connect: { id: entityId } } };
        break;
      case CommunicationLevel.EXHIBITOR:
        connect = { exhibitor: { connect: { id: entityId } } };
        break;

      default:
        connect = { whiteLabel: { connect: { id: entityId } } };
        break;
    }
    const communicationChannel = communicationChannelId
      ? null
      : await prisma.communicationChannel.create({
          data: {
            level: level || CommunicationLevel.WHITE_LABEL,
            ...connect,
          },
        });
    const whatsappChannel = await prisma.whatsappChannel.create({
      data: {
        communicationChannel: {
          connect: { id: communicationChannel?.id || communicationChannelId },
        },
        type: WhatsappChannelType.UNIFONIC,
        unifonicChannel: {
          create: {
            ...channelData,
          },
        },
      },
    });

    return { whatsappChannel };
  } catch (error) {
    return { error };
  }
};
// READ
export const getAllWhatsappChannels = async (): // userId: string
Promise<{
  whatsappChannels?: WhatsappChannel[];
  error?: any;
}> => {
  try {
    const whatsappChannels = await prisma.whatsappChannel.findMany();
    return { whatsappChannels };
  } catch (error) {
    return { error };
  }
};

export const getWhatsappChannelById = async (id: string) => {
  return await prisma.whatsappChannel.findUnique({
    where: { id },
  });
};

export const getWhatsappChannelByCommuncationChannelsId = async (
  communicationChannelId: string
) => {
  try {
    const whatsappChannel = await prisma.whatsappChannel.findUnique({
      where: { communicationChannelId },
    });
    return { whatsappChannel };
  } catch (error) {
    return { error };
  }
};

export const getWhatsappChannelDataByCommuncationChannelsIdWithTwilio = async (
  communicationChannelId: string
) => {
  try {
    const whatsappChannel = await prisma.whatsappChannel.findUnique({
      where: { communicationChannelId },
      include: {
        twilioChannel: true,
      },
    });

    return whatsappChannel;
  } catch (error) {
    return { error };
  }
};

// UPDATE
export const updateWhatsappChannelById = async (
  // userId: string,
  id: string,
  data: WhatsappChannel
) => {
  try {
    return await prisma.whatsappChannel.update({
      where: { id },
      data: {
        communicationChannel: { connect: { id: data.communicationChannelId } },
        type: data.type,
      },
    });
  } catch (error) {
    return error;
  }
};

export const updateWhatsappChannelByIdWithTwilio = async (
  id: string,
  accountSid: string,
  authToken: string | undefined,
  phoneNumber: string
) => {
  try {
    const whatsappChannel = await prisma.whatsappChannel.update({
      where: { id },
      data: {
        twilioChannel: {
          update: {
            accountSid,
            ...(authToken !== undefined && { authToken }),
            phoneNumber,
          },
        },
      },
    });
    return { whatsappChannel };
  } catch (error) {
    return { error };
  }
};

export const updateWhatsappChannelByIdWithUnifonic = async (
  // userId: string,
  id: string,
  channelData: UnifonicChannel
) => {
  try {
    const whatsappChannel = await prisma.whatsappChannel.update({
      where: { id },
      data: {
        unifonicChannel: {
          update: {
            ...channelData,
          },
        },
      },
    });
    return { whatsappChannel };
  } catch (error) {
    return { error };
  }
};

// DELETE
export const deleteWhatsappChannelById = async (
  // userId: string,
  id: string
) => {
  try {
    return await prisma.whatsappChannel.delete({
      where: { id },
    });
  } catch (error) {
    return error;
  }
};
